import React, { useEffect, useCallback, useState} from 'react';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import {setLoopsToFreeze} from 'actions/index.js';
import {connect} from 'react-redux';

const Freeze = ({loops, setLoopsToFreeze}) => { 
    return (
        <div>
          <div className="parameter-label">
            Loops To Freeze: {loops}
          </div>
          <ReactBootstrapSlider
            value={Math.log2(loops)}
            change={(e) => setLoopsToFreeze(Math.pow(2,e.target.value))}
            step={1}
            max={6}
            min={0}
            orientation="horizontal"
            reversed={false}
          />
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      loops: state.freeze.loops
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setLoopsToFreeze: x => dispatch(setLoopsToFreeze(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Freeze);
